<template>
  <div class="form-icons">
    <div class="icon-group">
      <div class="icon-group__icon">
        <svg
          fill="none"
          height="64"
          viewBox="0 0 64 64"
          width="64"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_118_165)">
            <path
              d="M53.5 0C43.0625 6.8125 31.9375 0 31.9375 0V64C33.125 63.4375 36.775 61.75 41.875 59.5C48.25 56.6875 50.3125 54.5 53.3125 51.1875C56.3125 47.875 57.75 43.6875 58.75 40.125C59.55 37.275 59.0833 32.1875 58.75 30C57.9214 24.5625 56.3125 22.05 56.3125 17.75C56.3125 13.45 57.9375 7.625 58.75 5.25L53.5 0Z"
              fill="#FFAC00"
            />
            <path
              d="M10.4417 0C20.8792 6.8125 32.0042 0 32.0042 0V64C30.8167 63.4375 27.1667 61.75 22.0667 59.5C15.6917 56.6875 13.6292 54.5 10.6292 51.1875C7.62921 47.875 6.19171 43.6875 5.19171 40.125C4.39171 37.275 4.85838 32.1875 5.19171 30C6.02029 24.5625 7.62921 22.05 7.62921 17.75C7.62921 13.45 6.00421 7.625 5.19171 5.25L10.4417 0Z"
              fill="#FFCD38"
            />
            <path
              d="M36.4375 24.125L32 16.625V46.875L36.4375 39.375H45.1875L40.9375 31.75L45.125 24.125H36.4375Z"
              fill="#E6E6E6"
            />
            <path
              d="M36.4375 24.125L32 16.625V46.875L36.4375 39.375H45.1875L40.9375 31.75L45.125 24.125H36.4375Z"
              fill="#E6E6E6"
            />
            <path
              d="M27.5 24.125L32 16.625V46.875L27.5 39.375H18.75L23 31.75L18.8125 24.125H27.5Z"
              fill="#E6E6E6"
            />
            <path
              d="M27.5 24.125L32 16.625V46.875L27.5 39.375H18.75L23 31.75L18.8125 24.125H27.5Z"
              fill="#F1F1F2"
            />
          </g>
          <defs>
            <clipPath id="clip0_118_165">
              <rect
                fill="white"
                height="64"
                width="64"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      Helping 10,000+ users
    </div>
    <div class="icon-group">
      <div class="icon-group__icon">
        <svg
          fill="none"
          height="65"
          viewBox="0 0 64 65"
          width="64"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="32"
            cy="32"
            fill="#F3625A"
            r="32"
          />
          <rect
            fill="#CCE6ED"
            height="17.625"
            width="41.875"
            x="11"
            y="2.625"
          />
          <path
            d="M31.4375 13.625C23.9375 10.25 20.0625 9.56251 11 9.87501C10.5 13.3542 10.2375 21.7 13.1875 26.5C16.1375 31.3 23.2917 31.625 26.5 31.1875H42.8125C50.8625 31.1875 52.7083 21.9375 52.625 17.3125C48.4792 17.5417 37.6643 16.4271 31.4375 13.625Z"
            fill="#FFCD38"
          />
          <path
            d="M10.875 44.25C10.875 38.0368 15.9118 33 22.125 33H41.625C47.8382 33 52.875 38.0368 52.875 44.25V55.5H10.875V44.25Z"
            fill="#A6D6EB"
          />
          <rect
            fill="#A6D6EB"
            height="12.125"
            width="14.875"
            x="11.125"
            y="2.375"
          />
          <path
            d="M26 11.4375C21.4375 9.625 15.1667 9.875 11.1875 9.875V21C11.1875 29.25 23.3542 31.5208 29.4375 31.625V54.8125L34.875 50.125V29.875C30.659 29.875 28.1974 26.576 26.8538 23.434C26.1803 21.8589 26 20.1314 26 18.4183V11.4375Z"
            fill="#FFAC00"
          />
          <path
            d="M31 51.1875C36.65 47.7875 47.9375 46.9792 52.875 47V56.25C40.893 66.5408 23.2023 66.5755 11.1801 56.3317L10.9375 56.125V54.5C15.2708 54.8125 25.35 54.5875 31 51.1875Z"
            fill="#FFCD38"
          />
          <path
            d="M34.7759 31.5V31.5C44.8408 31.5 53 23.3408 53 13.2759V2.5H11V13.3965C11 23.3948 19.1052 31.5 29.1034 31.5V31.5"
            stroke="#E8F8FC"
            stroke-linecap="round"
            stroke-width="3"
          />
          <path
            d="M29.0991 32.0002V32.0002C19.0342 32.0002 10.875 40.1594 10.875 50.2243L10.875 54.1255L12.2722 55.2543C24.2251 64.9109 41.4139 64.4859 52.875 54.2505V54.2505L52.875 50.1036C52.875 40.1054 44.7698 32.0002 34.7715 32.0002V32.0002"
            stroke="#E8F8FC"
            stroke-linecap="round"
            stroke-width="3"
          />
          <rect
            fill="#AA5821"
            height="4"
            rx="2"
            width="49.875"
            x="7"
          />
          <path
            d="M7 2C7 0.895431 7.89543 0 9 0H18.75L17.7394 0.710451C16.6183 1.49866 15.8223 2.66793 15.5 4H9C7.89543 4 7 3.10457 7 2Z"
            fill="#83441B"
          />
        </svg>
      </div>
      15 mins to set-up
    </div>
    <div class="icon-group">
      <div class="icon-group__icon">
        <svg
          fill="none"
          height="64"
          viewBox="0 0 64 64"
          width="64"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M49.625 0H3.125C1.39911 0 0 1.39911 0 3.125V10.25C0 11.9759 1.39911 13.375 3.125 13.375H7.35908C7.79582 13.375 8.2009 13.603 8.42756 13.9763L10.1709 16.8477C10.6601 17.6535 11.8313 17.6484 12.3135 16.8383L14.0115 13.9856C14.2369 13.607 14.645 13.375 15.0856 13.375H49.625C51.3509 13.375 52.75 11.9759 52.75 10.25V3.125C52.75 1.39911 51.3509 0 49.625 0Z"
            fill="#D85049"
          />
          <path
            d="M52.8125 4.625H5.3125C4.62214 4.625 4.0625 5.18464 4.0625 5.875V13.375H7.42158C7.85832 13.375 8.2634 13.603 8.49006 13.9763L10.2334 16.8477C10.7226 17.6535 11.8938 17.6484 12.376 16.8383L14.074 13.9856C14.2994 13.607 14.7075 13.375 15.1481 13.375H49.6472C51.3644 13.375 52.7599 11.9895 52.7722 10.2723L52.8125 4.625Z"
            fill="#F3625A"
          />
          <path
            d="M10 6.8125C10 8.43484 8.68484 9.75 7.0625 9.75C5.44016 9.75 4.125 8.43484 4.125 6.8125C4.125 5.19016 5.44016 3.875 7.0625 3.875C8.68484 3.875 10 5.19016 10 6.8125Z"
            fill="#FF8A84"
          />
          <rect
            fill="#B83E37"
            height="2"
            rx="1"
            width="25.125"
            x="12.625"
            y="3.25"
          />
          <rect
            fill="#B83E37"
            height="2"
            rx="1"
            width="7.75"
            x="39.75"
            y="3.25"
          />
          <rect
            fill="#B83E37"
            height="2"
            rx="1"
            width="25.125"
            x="12.625"
            y="8"
          />
          <rect
            fill="#B83E37"
            height="2"
            rx="1"
            width="7.75"
            x="39.75"
            y="8"
          />
          <path
            d="M49.625 45.375H3.125C1.39911 45.375 0 46.7741 0 48.5V55.625C0 57.3509 1.39911 58.75 3.125 58.75H7.35908C7.79582 58.75 8.2009 58.978 8.42756 59.3513L10.1709 62.2227C10.6601 63.0285 11.8313 63.0234 12.3135 62.2133L14.0115 59.3606C14.2369 58.982 14.645 58.75 15.0856 58.75H49.625C51.3509 58.75 52.75 57.3509 52.75 55.625V48.5C52.75 46.7741 51.3509 45.375 49.625 45.375Z"
            fill="#D85049"
          />
          <path
            d="M52.8125 50H5.3125C4.62214 50 4.0625 50.5596 4.0625 51.25V58.75H7.42158C7.85832 58.75 8.2634 58.978 8.49006 59.3513L10.2334 62.2227C10.7226 63.0285 11.8938 63.0234 12.376 62.2133L14.074 59.3606C14.2994 58.982 14.7075 58.75 15.1481 58.75H49.6472C51.3644 58.75 52.7599 57.3645 52.7722 55.6473L52.8125 50Z"
            fill="#F3625A"
          />
          <path
            d="M10 52.1875C10 53.8098 8.68484 55.125 7.0625 55.125C5.44016 55.125 4.125 53.8098 4.125 52.1875C4.125 50.5652 5.44016 49.25 7.0625 49.25C8.68484 49.25 10 50.5652 10 52.1875Z"
            fill="#FF8A84"
          />
          <rect
            fill="#B83E37"
            height="2"
            rx="1"
            width="25.125"
            x="12.625"
            y="48.625"
          />
          <rect
            fill="#B83E37"
            height="2"
            rx="1"
            width="7.75"
            x="39.75"
            y="48.625"
          />
          <rect
            fill="#B83E37"
            height="2"
            rx="1"
            width="25.125"
            x="12.625"
            y="53.375"
          />
          <rect
            fill="#B83E37"
            height="2"
            rx="1"
            width="7.75"
            x="39.75"
            y="53.375"
          />
          <path
            d="M14.3125 24.125H60.8125C62.5384 24.125 63.9375 25.5241 63.9375 27.25V34.375C63.9375 36.1009 62.5384 37.5 60.8125 37.5H56.5784C56.1417 37.5 55.7366 37.728 55.5099 38.1013L53.7666 40.9727C53.2774 41.7785 52.1062 41.7734 51.624 40.9633L49.926 38.1106C49.7006 37.732 49.2925 37.5 48.8519 37.5H14.3125C12.5866 37.5 11.1875 36.1009 11.1875 34.375V27.25C11.1875 25.5241 12.5866 24.125 14.3125 24.125Z"
            fill="#FFAC00"
          />
          <path
            d="M11.125 28.75H58.625C59.3154 28.75 59.875 29.3096 59.875 30V37.5H56.5159C56.0792 37.5 55.6741 37.728 55.4474 38.1013L53.7041 40.9727C53.2149 41.7785 52.0437 41.7734 51.5615 40.9633L49.8635 38.1106C49.6381 37.732 49.23 37.5 48.7894 37.5H14.2903C12.5731 37.5 11.1776 36.1145 11.1653 34.3973L11.125 28.75Z"
            fill="#FFCD38"
          />
          <path
            d="M53.9375 30.9375C53.9375 32.5598 55.2527 33.875 56.875 33.875C58.4973 33.875 59.8125 32.5598 59.8125 30.9375C59.8125 29.3152 58.4973 28 56.875 28C55.2527 28 53.9375 29.3152 53.9375 30.9375Z"
            fill="#FFDB6F"
          />
          <rect
            fill="#DD990D"
            height="2"
            rx="1"
            transform="matrix(-1 0 0 1 51.3125 27.375)"
            width="25.125"
          />
          <rect
            fill="#DD990D"
            height="2"
            rx="1"
            transform="matrix(-1 0 0 1 24.1875 27.375)"
            width="7.75"
          />
          <rect
            fill="#DD990D"
            height="2"
            rx="1"
            transform="matrix(-1 0 0 1 51.3125 32.125)"
            width="25.125"
          />
          <rect
            fill="#DD990D"
            height="2"
            rx="1"
            transform="matrix(-1 0 0 1 24.1875 32.125)"
            width="7.75"
          />
        </svg>
      </div>
      Onboarding call (& unlimited livechat support)
    </div>
  </div>
</template>

<style lang="scss" scoped>
.form-icons {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  border: 1px solid #D8D8D8;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 1rem;
  gap: 1rem;
  max-width: 31%;

  align-items: center;
  justify-content: center;

  .icon-group {
    display: flex;
    align-items: center;
    gap: 1rem;
    height: 100%;
  }
}

@media only screen and (max-width: 900px) {
  .form-container {
    flex-direction: column-reverse;
  }

  .form-icons {
    flex-direction: row;
    max-width: 100%;
    justify-content: space-evenly;
  }

  .icon-group {
    flex-direction: column;
    text-align: center;
  }
}
@media only screen and (max-width: 479px) {
  .form-icons {
    flex-direction: column;

    .icon-group {
      width: 100%;
      border-bottom: 1px solid #eee;
      padding-bottom: 0.9rem;
      margin: 0 2rem;

      &:last-of-type {
        border: 0;
        padding-bottom: 0;
      }
    }
  }
}
</style>
